import { resolveComponent, openBlock, createElementBlock, createVNode, createSlots, withCtx, renderSlot, createElementVNode, normalizeClass, createBlock, createCommentVNode } from 'vue';

const _hoisted_1 = { class: "el-dropdown" };
function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _a;
  const _component_el_dropdown_collection = resolveComponent("el-dropdown-collection");
  const _component_el_roving_focus_group = resolveComponent("el-roving-focus-group");
  const _component_el_focus_trap = resolveComponent("el-focus-trap");
  const _component_el_scrollbar = resolveComponent("el-scrollbar");
  const _component_el_tooltip = resolveComponent("el-tooltip");
  const _component_el_button = resolveComponent("el-button");
  const _component_arrow_down = resolveComponent("arrow-down");
  const _component_el_icon = resolveComponent("el-icon");
  const _component_el_button_group = resolveComponent("el-button-group");
  return openBlock(), createElementBlock("div", _hoisted_1, [
    createVNode(_component_el_tooltip, {
      ref: "popperRef",
      effect: _ctx.effect,
      "fallback-placements": ["bottom", "top", "right", "left"],
      "gpu-acceleration": false,
      "hide-after": _ctx.hideTimeout,
      "manual-mode": true,
      placement: _ctx.placement,
      "popper-class": `el-dropdown__popper ${_ctx.popperClass}`,
      "reference-element": (_a = _ctx.referenceElementRef) == null ? void 0 : _a.$el,
      trigger: _ctx.trigger,
      "show-after": _ctx.showTimeout,
      "stop-popper-mouse-event": false,
      "virtual-ref": _ctx.triggeringElementRef,
      "virtual-triggering": _ctx.splitButton,
      "append-to-body": "",
      pure: "",
      transition: "el-zoom-in-top",
      persistent: "",
      onShow: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("visible-change", true)),
      onHide: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("visible-change", false))
    }, createSlots({
      content: withCtx(() => [
        createVNode(_component_el_scrollbar, {
          ref: "scrollbar",
          "wrap-style": _ctx.wrapStyle,
          tag: "ul",
          "view-class": "el-dropdown__list"
        }, {
          default: withCtx(() => [
            createVNode(_component_el_focus_trap, {
              trapped: "",
              onMountOnFocus: _ctx.onMountOnFocus
            }, {
              default: withCtx(() => [
                createVNode(_component_el_roving_focus_group, {
                  loop: _ctx.loop,
                  "current-tab-id": _ctx.currentTabId,
                  orientation: "horizontal",
                  onCurrentTabIdChange: _ctx.handleCurrentTabIdChange,
                  onEntryFocus: _ctx.handleEntryFocus
                }, {
                  default: withCtx(() => [
                    createVNode(_component_el_dropdown_collection, null, {
                      default: withCtx(() => [
                        renderSlot(_ctx.$slots, "dropdown")
                      ]),
                      _: 3
                    })
                  ]),
                  _: 3
                }, 8, ["loop", "current-tab-id", "onCurrentTabIdChange", "onEntryFocus"])
              ]),
              _: 3
            }, 8, ["onMountOnFocus"])
          ]),
          _: 3
        }, 8, ["wrap-style"])
      ]),
      _: 2
    }, [
      !_ctx.splitButton ? {
        name: "default",
        fn: withCtx(() => [
          createElementVNode("div", {
            class: normalizeClass(_ctx.dropdownTriggerKls)
          }, [
            renderSlot(_ctx.$slots, "default")
          ], 2)
        ])
      } : void 0
    ]), 1032, ["effect", "hide-after", "placement", "popper-class", "reference-element", "trigger", "show-after", "virtual-ref", "virtual-triggering"]),
    _ctx.splitButton ? (openBlock(), createBlock(_component_el_button_group, { key: 0 }, {
      default: withCtx(() => [
        createVNode(_component_el_button, {
          ref: "referenceElementRef",
          size: _ctx.dropdownSize,
          type: _ctx.type,
          onClick: _ctx.handlerMainButtonClick
        }, {
          default: withCtx(() => [
            renderSlot(_ctx.$slots, "default")
          ]),
          _: 3
        }, 8, ["size", "type", "onClick"]),
        createVNode(_component_el_button, {
          ref: "triggeringElementRef",
          size: _ctx.dropdownSize,
          type: _ctx.type,
          class: "el-dropdown__caret-button"
        }, {
          default: withCtx(() => [
            createVNode(_component_el_icon, { class: "el-dropdown__icon" }, {
              default: withCtx(() => [
                createVNode(_component_arrow_down)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["size", "type"])
      ]),
      _: 3
    })) : createCommentVNode("v-if", true)
  ]);
}

export { render };
//# sourceMappingURL=dropdown.vue_vue_type_template_id_3ed790a5_lang.mjs.map
